import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/images/favicon.png'


const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo-icon",
  width: "60",
  height: "60"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold ms-10" }, "Virtualia", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "sidebar-menu" }
const _hoisted_8 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }, null, -1)
const _hoisted_10 = { class: "sidebar-nav-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-more-1" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Dashboard", -1)
const _hoisted_13 = { class: "sidebar-nav-item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-award-1" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("Changelog "),
  /*#__PURE__*/_createElementVNode("span", { class: "badge text-bg-light rounded-pill fs-11 d-inline-block" }, "Beta 1.0.0")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("li", { class: "sub-title sidebar-nav-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block text-uppercase fw-medium" }, "Aplicación")
], -1)
const _hoisted_17 = { class: "sidebar-nav-item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chat-1" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Mis Chats", -1)
const _hoisted_20 = {
  key: 0,
  class: "sidebar-nav-item"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chat" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Chats", -1)
const _hoisted_23 = {
  key: 1,
  class: "sidebar-nav-item"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-communication" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Chats Control", -1)
const _hoisted_26 = { class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseSix",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseSix"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-people" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Contactos y prospecto")
], -1)
const _hoisted_28 = {
  id: "sidebarCollapseSix",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_29 = { class: "accordion-body" }
const _hoisted_30 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_31 = { class: "sidebar-sub-menu-item" }
const _hoisted_32 = { class: "sidebar-sub-menu-item" }
const _hoisted_33 = {
  key: 2,
  class: "sub-title sidebar-nav-item"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-uppercase fw-medium" }, "Conexiones", -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 3,
  class: "sidebar-nav-item"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-phone-call" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Teléfonos", -1)
const _hoisted_39 = {
  key: 4,
  class: "sub-title sidebar-nav-item"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-uppercase fw-medium" }, "Mantenedores", -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  key: 5,
  class: "sidebar-nav-item"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user-3" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Usuarios", -1)
const _hoisted_45 = {
  key: 6,
  class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapseSeven",
  "aria-expanded": "false",
  "aria-controls": "sidebarCollapseSeven"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-layer-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Negocios y campañas")
], -1)
const _hoisted_47 = {
  id: "sidebarCollapseSeven",
  class: "accordion-collapse collapse",
  "data-bs-parent": "#sidebarNavAccordion"
}
const _hoisted_48 = { class: "accordion-body" }
const _hoisted_49 = { class: "sidebar-sub-menu ps-0 mb-0 list-unstyled" }
const _hoisted_50 = { class: "sidebar-sub-menu-item" }
const _hoisted_51 = { class: "sidebar-sub-menu-item" }
const _hoisted_52 = {
  key: 7,
  class: "sidebar-nav-item"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-edit" }, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Finalizadores", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
    'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
    { active: _ctx.stateStoreInstance.open },
  ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-flex align-items-center text-white text-decoration-none"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("button", {
        class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
      }, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("li", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: { name: 'dashboard' },
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_11,
              _hoisted_12
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_13, [
          _createVNode(_component_router_link, {
            to: { name: 'changelog' },
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_14,
              _hoisted_15
            ]),
            _: 1
          })
        ]),
        _hoisted_16,
        _createElementVNode("li", _hoisted_17, [
          _createVNode(_component_router_link, {
            to: { name: 'mis-chats' },
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_18,
              _hoisted_19
            ]),
            _: 1
          })
        ]),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
              _createVNode(_component_router_link, {
                to: { name: 'chats' },
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_21,
                  _hoisted_22
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
              _createVNode(_component_router_link, {
                to: { name: 'chats-control' },
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_24,
                  _hoisted_25
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("ul", _hoisted_30, [
                _createElementVNode("li", _hoisted_31, [
                  _createVNode(_component_router_link, {
                    to: { name: 'contactos' },
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Contactos ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_32, [
                  _createVNode(_component_router_link, {
                    to: { name: 'prospectos' },
                    class: "sidebar-sub-menu-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Prospecto ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("li", _hoisted_33, _hoisted_35))
          : _createCommentVNode("", true),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
              _createVNode(_component_router_link, {
                to: { name: 'telefonos' },
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_37,
                  _hoisted_38
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("li", _hoisted_39, _hoisted_41))
          : _createCommentVNode("", true),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
              _createVNode(_component_router_link, {
                to: { name: 'usuarios' },
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_43,
                  _hoisted_44
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("ul", _hoisted_49, [
                    _createElementVNode("li", _hoisted_50, [
                      _createVNode(_component_router_link, {
                        to: { name: 'negocios' },
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Negocios ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_51, [
                      _createVNode(_component_router_link, {
                        to: { name: 'campanas' },
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Campañas ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("li", _hoisted_52, [
              _createVNode(_component_router_link, {
                to: { name: 'finalizadores'},
                class: "sidebar-nav-link d-block"
              }, {
                default: _withCtx(() => [
                  _hoisted_53,
                  _hoisted_54
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}